import * as types from 'redux/actions/actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import paths from 'redux/paths';
import { getLicenseByUser, getDAOList } from 'redux/actions/codeBase2/codeBase2.action';

// Action types
export const FETCH_DAO_LIST_REQUEST = 'FETCH_DAO_LIST_REQUEST';
export const FETCH_DAO_LIST_SUCCESS = 'FETCH_DAO_LIST_SUCCESS';
export const FETCH_DAO_LIST_FAILURE = 'FETCH_DAO_LIST_FAILURE';

export const FETCH_DAO_DETAIL_REQUEST = 'FETCH_DAO_DETAIL_REQUEST';
export const FETCH_DAO_DETAIL_SUCCESS = 'FETCH_DAO_DETAIL_SUCCESS';
export const FETCH_DAO_DETAIL_FAILURE = 'FETCH_DAO_DETAIL_FAILURE';

export const FETCH_DAO_MEMBERS_REQUEST = 'FETCH_DAO_MEMBERS_REQUEST';
export const FETCH_DAO_MEMBERS_SUCCESS = 'FETCH_DAO_MEMBERS_SUCCESS';
export const FETCH_DAO_MEMBERS_FAILURE = 'FETCH_DAO_MEMBERS_FAILURE';

export const FETCH_DAO_VOTING_HISTORY_REQUEST = 'FETCH_DAO_VOTING_HISTORY_REQUEST';
export const FETCH_DAO_VOTING_HISTORY_SUCCESS = 'FETCH_DAO_VOTING_HISTORY_SUCCESS';
export const FETCH_DAO_VOTING_HISTORY_FAILURE = 'FETCH_DAO_VOTING_HISTORY_FAILURE';

export const FETCH_DAO_LICENSE_REQUEST = 'FETCH_DAO_LICENSE_REQUEST';
export const FETCH_DAO_LICENSE_SUCCESS = 'FETCH_DAO_LICENSE_SUCCESS';
export const FETCH_DAO_LICENSE_FAILURE = 'FETCH_DAO_LICENSE_FAILURE';

export const FETCH_DAO_CODEBASES_REQUEST = 'FETCH_DAO_CODEBASES_REQUEST';
export const FETCH_DAO_CODEBASES_SUCCESS = 'FETCH_DAO_CODEBASES_SUCCESS';
export const FETCH_DAO_CODEBASES_FAILURE = 'FETCH_DAO_CODEBASES_FAILURE';

// Action creators
export const fetchDaoList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_LIST_REQUEST });
    await dispatch(getLicenseByUser());
    const response = await dispatch(getDAOList());
    dispatch({ type: FETCH_DAO_LIST_SUCCESS, payload: response });
    return response;
  } catch (error) {
    console.error('Error fetching DAO list:', error);
    dispatch({ type: FETCH_DAO_LIST_FAILURE, error: error.message });
    throw error;
  }
};

export const fetchDaoDetail = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_DETAIL_REQUEST });

    const res = await client.sendRequest({
      path: `/daos/${daoId}`,
      method: 'get',
      // headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      console.error('DAO detail API error:', res.error);
      throw new Error(res.error);
    }

    dispatch({
      type: FETCH_DAO_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.error('Error in fetchDaoDetail:', error);
    dispatch({
      type: FETCH_DAO_DETAIL_FAILURE,
      error: error.message || 'An unexpected error occurred while loading DAO information.',
    });
  }
};

export const fetchDaoMembers = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_MEMBERS_REQUEST });
    await dispatch(getLicenseByUser());
    const response = await dispatch(getDAOList());
    const dao = response.find((d) => d._id === daoId);
    const members = dao?.partners || [];
    dispatch({ type: FETCH_DAO_MEMBERS_SUCCESS, payload: members });
    return members;
  } catch (error) {
    console.error('Error fetching DAO members:', error);
    dispatch({ type: FETCH_DAO_MEMBERS_FAILURE, error: error.message });
    throw error;
  }
};

export const fetchDaoVotingHistory = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_VOTING_HISTORY_REQUEST });
    await dispatch(getLicenseByUser());
    const response = await dispatch(getDAOList());
    const dao = response.find((d) => d._id === daoId);
    const history = dao?.votingHistory || [];
    dispatch({ type: FETCH_DAO_VOTING_HISTORY_SUCCESS, payload: history });
    return history;
  } catch (error) {
    console.error('Error fetching DAO voting history:', error);
    dispatch({ type: FETCH_DAO_VOTING_HISTORY_FAILURE, error: error.message });
    throw error;
  }
};

export const fetchDaoLicense = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_LICENSE_REQUEST });
    const response = await dispatch(getLicenseByUser());
    dispatch({
      type: FETCH_DAO_LICENSE_SUCCESS,
      payload: response,
    });
    return response;
  } catch (error) {
    console.error('Error fetching DAO license:', error);
    dispatch({
      type: FETCH_DAO_LICENSE_FAILURE,
      error: error.message,
    });
    throw error;
  }
};

export const fetchDaoCodebases = (daoId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DAO_CODEBASES_REQUEST });

    const res = await client.sendRequest({
      path: `/code-bases/get-by-dao-id/${daoId}`,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      console.error('DAO codebases API error:', res.error);
      throw new Error(res.error);
    }

    dispatch({
      type: FETCH_DAO_CODEBASES_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    console.error('Error in fetchDaoCodebases:', error);
    dispatch({
      type: FETCH_DAO_CODEBASES_FAILURE,
      error: error.message || 'An unexpected error occurred while loading DAO codebases.',
    });
    throw error;
  }
};
